import Api, { CompletionStatus, SuccessStatus, Exit, searchConnection } from "./API";

class Api1_2 extends Api {


	/**
	 * Begins a communication session with the LMS.
	 */
	initialize():boolean {
		return this.connection.LMSInitialize('');
	}
	
	/**
	 * Ends a communication session with the LMS.
	 */
	terminate() {
		return this.connection.LMSFinish('');
	}
	
	/**
	 * Commits/Stores values set with setValue (some LMS (1.2) seem to needs this)
	 */
	commit():boolean{
		return this.connection.LMSCommit('');
	}
	
	
	/**
	 * Sets a value to the LMS.
	 * @param element Possible values see: http://scorm.com/scorm-explained/technical-scorm/run-time/run-time-reference/
	 * @param value The value
	 */
	setValue( element: string, value: string ): string {
		return this.connection.LMSSetValue( element, value );
	}
	/**
	 * Retrieves a value from the LMS
	 * @param element Possible values see: http://scorm.com/scorm-explained/technical-scorm/run-time/run-time-reference/
	 */
	
	getValue( element: string ):string {
		return this.connection.LMSGetValue( element );
	}
	
	getLastError():string {
		return this.connection.LMSGetLastError('');
		
	}
	getErrorString( errorCode: string ):string {
		return this.connection.LMSGetErrorString( errorCode );
	}
	
	getDiagnostic( errorCode: string ):string {
		return this.connection.LMSGetDiagnostic( errorCode );
	}


	/**
	 * Sets the score
	 * @param score Number that reflects the performance of the learner relative to the range bounded by the values of min and max
	 */
	set score( score: number ) {
		this.setValue( 'cmi.core.score.raw', score.toString() );
	}
	
	/** 
	 * Gets the score
	 */
	get score(): number {
		return parseInt( this.getValue( 'cmi.core.score.raw' ) );
	}
	
	/**
	 * Setus the maximum score
	 * @param maxScore Maximum value in the range for the score
	 */
	set maxScore( maxScore: number ) {
		this.setValue( 'cmi.core.score.max', maxScore.toString() );
	}
	
	/**
	 * Gets the maximum score
	 */
	get maxScore(): number {
		return parseInt( this.getValue( 'cmi.core.score.max' ) );
	}
	
	/**
	 * Setus the minimum score
	 * @param minScore Minimum value in the range for the score
	 */
	set minScore( minScore: number ) {
		this.setValue( 'cmi.core.score.min', minScore.toString() );
	}
	
	/**
	 * Gets the minimum score
	 */
	get minScore(): number {
		return parseInt( this.getValue( 'cmi.core.score.min' ) );
	}
	
	/**
	 * Set the completion status
	 * @param CompletionStatus Indicates whether the learner has completed the SCO
	 */
	set completionStatus( completionStatus:CompletionStatus ) {
		this.setValue( 'cmi.core.lesson_status', completionStatus );
	}
	
	/**
	 * Gets the completion status
	 */
	get completionStatus():CompletionStatus {
		return this.getValue( 'cmi.core.lesson_status' ) as CompletionStatus;
	}
	
	/**
	 * Sets the success status
	 * @param successStatus SuccessStatus Indicates whether the learner has mastered the SCO
	 */
	set successStatus( successStatus: SuccessStatus ) {
		this.setValue( 'cmi.core.lesson_status', successStatus );
	}
	
	/**
	 * Gets the success status
	 */
	get successStatus(): SuccessStatus {
		return this.getValue( 'cmi.core.lesson_status' ) as SuccessStatus;
	}
	
	/**
	 * Sets the exit value
	 * @param exit Exit Indicates how or why the learner left the SCO
	 */
	set exit( exit: Exit ) {
		this.setValue( 'cmi.core.exit', exit );
	}
	
	/**
	 * Sets the elapsed session time
	 */
	set sessionTime( time: Date ) {
		this.setValue( 'cmi.core.session_time', 'PT' + time.getHours() + 'H' + time.getMinutes() + 'M' + time.getSeconds() + 'S' );
	}
	
	/**
	 * Sets the location value
	 * @param l string The learner’s current location in the SCO
	 */
	set location( l: string ) {
		this.setValue( 'cmi.core.lesson_location', l );
	}
	
	/**
	 * Gets the location value
	 */
	get location(): string {
		return this.getValue( 'cmi.core.lesson_location' );
	}
	
	/**
	 * Sets the suspend data value
	 * @param d string Provides space to store and retrieve data between learner sessions
	 */
	set suspendData( d: string ) {
		this.setValue( 'cmi.suspend_data', d );
	}
	
	/**
	 * Gets the suspend data value
	 */
	get suspendData(): string {
		return this.getValue( 'cmi.suspend_data' );
	}

	static find() {
		var connection = searchConnection( 'API' );
		return ( connection ) ? new Api1_2( connection ) : null;
	}
}

export default Api1_2;

